'use strict';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));
var _ = require('lodash');
var AnalysisMetricFactory = function AnalysisMetricFactory(constants) {
  function AnalysisMetric(screenName) {
    switch (screenName) {
      case constants.MARKET_SCREEN:
        this.metrics = require('../config/marketMetrics.json');
        this.defaultMetric = 'bookings';
        break;
      case constants.FLIGHT_SCREEN:
        this.metrics = require('../config/flightMetrics.json');
        this.defaultMetric = 'loadFactor';
        break;
      case constants.STRATEGY_SCREEN:
        this.metrics = require('../config/strategyListingMetrics.json');
        this.defaultMetric = 'strategy';
        break;
      case constants.RULE_SCREEN:
        this.metrics = require('../config/ruleListingMetrics.json');
        this.defaultMetric = 'rule';
        break;
      case constants.DATA_EXTRACT_SCREEN:
        this.metrics = require('../config/dataExtractMetrics.json');
        this.defaultMetric = 'level';
        break;
      case constants.SYSTEM_STATUS_SCREEN:
      case constants.EVENTS_SCREEN:
      case constants.ENTITY_SCREEN:
        this.metrics = require('../config/systemConfigurationMetrics.json');
        this.defaultMetric = 'level';
        break;
      case constants.DEMAND_TRANSPARENCY_SCREEN:
        this.metrics = require('../config/demandTransparency.json');
        this.defaultMetric = 'level';
        break;
      case constants.FARES_SCREEN:
        this.metrics = require('../config/faresMetrics.json');
        this.defaultMetric = 'level';
        break;
      case constants.DASHBOARD_SCREEN:
        this.metrics = require('../config/dashboardMetrics.json');
        this.defaultMetric = 'bookings';
        break;
      case constants.SEASONALITY_SCREEN:
        this.metrics = require('../config/seasonalityMetrics.json');
        this.defaultMetric = 'Total Bookings';
        break;
      case constants.ROM_ANALYSIS_SCREEN:
        this.metrics = require('../config/romAnalysisMetrics.json');
        this.defaultMetric = 'individualAndGrouped';
        break;
      case constants.ROM_SUMMARY_SCREEN:
        this.metrics = require('../config/romSummaryMetrics.json');
        this.defaultMetric = 'individualAndGrouped';
        break;
      case constants.USER_MANAGEMENT_SCREEN:
        this.metrics = require('../config/userManagement.json');
        this.defaultMetric = 'level';
        break;
      case constants.PRICING_ANALYSIS_SCREEN:
        this.metrics = require('../config/flexPricing.json');
        this.defaultMetric = 'level';
        break;
      case constants.PRICING_SUMMARY_SCREEN:
        this.metrics = require('../config/pricingSummaryMetrics.json');
        this.defaultMetric = 'level';
        break;
      case constants.CALIBRATION_ANALYSIS_SCREEN:
        this.metrics = require('../config/calibrationAnalysisMetrics.json');
        this.defaultMetric = 'level';
        break;
      case constants.ONLINE_LOGIT_CALIBRATION_REVIEW_SCREEN:
        this.metrics = require('../config/onlineLogitCalibrationReviewAnalysisMetrics.json');
        this.defaultMetric = 'level';
        break;
    }
  }
  function getMetricKey(mode, targetType) {
    var key = mode;
    if (targetType) {
      key += '-' + targetType;
    }
    return key;
  }

  /**
   * @param {string} mode - "market" or "service"
   * @param {=string} targetType
   * @returns {Array}
   */
  AnalysisMetric.prototype.getAvailableMetrics = function (mode, targetType) {
    if (this.hasMetrics(mode, targetType)) {
      return Object.keys(this.getMetrics(mode, targetType));
    } else {
      throw new Error('not existing mode "' + mode + '" with target "' + (targetType || '-') + '" was passed');
    }
  };

  /**
   * @param {string} mode - "market" or "service"
   * @param {string} targetType
   * @returns {Array}
   */
  AnalysisMetric.prototype.getAvailableLabels = function (mode, targetType) {
    return this.getAvailableMetrics(mode, targetType).map(function (metric) {
      return {
        label: _.startCase(metric),
        id: metric
      };
    });
  };
  AnalysisMetric.prototype.getDefault = function () {
    return this.defaultMetric;
  };

  /**
   * @param {string} mode - "market" or "service"
   * @param {string} metric
   * @param {string} targetType
   * @returns {*}
   */
  AnalysisMetric.prototype.getMetricValues = function (mode, metric, targetType, dimension) {
    if (this.hasMetrics(mode, targetType)) {
      var dataKeyObj;
      var metrics = this.getMetrics(mode, targetType)[metric || this.defaultMetric];
      if (metrics) {
        dataKeyObj = dimension && metrics[dimension] ? metrics[dimension] : metrics.regular || metrics;
      }
      return dataKeyObj;
    } else {
      throw new Error('not existing mode "' + mode + '" with target "' + (targetType || '-') + '" was passed');
    }
  };
  /**
   * @param {string} mode - "market" or "service"
   * @param {string} metric
   * @param {string} targetType
   * @returns {Array}
   */
  AnalysisMetric.prototype.getDataKeys = function (mode, metric, targetType, dimension) {
    if (this.hasMetrics(mode, targetType)) {
      var metrics = this.getMetrics(mode, targetType)[metric];
      var dataKeyObj;
      if (metrics) {
        dataKeyObj = dimension && metrics[dimension] ? metrics[dimension] : metrics.regular || metrics;
      }
      return _.map(dataKeyObj, 'dataKey');
    } else {
      throw new Error('not existing mode "' + mode + '" with target "' + (targetType || '-') + '" was passed');
    }
  };

  /**
   * @param {string} mode - "market" or "service"
   * @param {string} targetType - "date-range-level"
   * @returns {*}
   */
  AnalysisMetric.prototype.hasMetrics = function (mode, targetType) {
    return (0, _typeof2["default"])(this.metrics[getMetricKey(mode, targetType)]) === 'object' ? true : false;
  };

  /**
   * @param {string} mode - "market" or "service"
   * @param {string} targetType - "date-range-level"
   * @returns {*}
   */
  AnalysisMetric.prototype.getMetrics = function (mode, targetType) {
    return this.metrics[getMetricKey(mode, targetType)];
  };
  return AnalysisMetric;
};
AnalysisMetricFactory.$inject = ['DataRetrieverConstantsService'];
module.exports = AnalysisMetricFactory;